import { BaseContainerModel } from '../base-container.model';
import { bl_mkp_seller_order_hdr_RowClass, bl_mkp_seller_order_hdr_RowInterface, bl_mkp_seller_order_lines_RowInterface } from '../../dbschema';


export class MkpSellerOrderContainerModel extends BaseContainerModel {
  bl_mkp_seller_order_hdr: bl_mkp_seller_order_hdr_RowInterface = new bl_mkp_seller_order_hdr_RowClass();
  bl_mkp_seller_order_lines: bl_mkp_seller_order_lines_RowInterface[] = [];
}